/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedChecklistsRouteImport } from './routes/_authed/checklists'
import { Route as AuthedEvidenceRouteImport } from './routes/_authed/evidence'
import { Route as AuthedExportsRouteImport } from './routes/_authed/exports'
import { Route as AuthedFilesRouteImport } from './routes/_authed/files'
import { Route as AuthedGanttRouteImport } from './routes/_authed/gantt'
import { Route as AuthedLeadsRouteImport } from './routes/_authed/leads'
import { Route as AuthedNoAccessRouteImport } from './routes/_authed/no-access'
import { Route as AuthedPeopleRouteImport } from './routes/_authed/people'
import { Route as AuthedSearchRouteImport } from './routes/_authed/search'
import { Route as AuthedStartRouteImport } from './routes/_authed/start'
import { Route as AuthedTasksRouteImport } from './routes/_authed/tasks'
import { Route as AuthedVerificationRouteImport } from './routes/_authed/verification'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedAdminFreezesRouteImport } from './routes/_authed/admin/freezes'
import { Route as AuthedAdminImportsRouteImport } from './routes/_authed/admin/imports'
import { Route as AuthedAdminPacksRouteImport } from './routes/_authed/admin/packs'
import { Route as AuthedAdminPurgeRouteImport } from './routes/_authed/admin/purge'
import { Route as AuthedAdminUsersRouteImport } from './routes/_authed/admin/users'
import { Route as AuthedChecklistsIndexRouteImport } from './routes/_authed/checklists.index'
import { Route as AuthedEvidenceIndexRouteImport } from './routes/_authed/evidence.index'
import { Route as AuthedEvidenceCodeRouteImport } from './routes/_authed/evidence.$code'
import { Route as AuthedLeadsIndexRouteImport } from './routes/_authed/leads/index'
import { Route as AuthedLeadsCapacityRouteImport } from './routes/_authed/leads/capacity'
import { Route as AuthedStartIndexRouteImport } from './routes/_authed/start.index'
import { Route as AuthedStartCompletionRouteImport } from './routes/_authed/start.completion'
import { Route as AuthedStartQuizRouteImport } from './routes/_authed/start.quiz'
import { Route as AuthedTasksIndexRouteImport } from './routes/_authed/tasks.index'
import { Route as AuthedTasksTaskIdRouteImport } from './routes/_authed/tasks.$taskId'
import { Route as AuthedChecklistsCodeIndexRouteImport } from './routes/_authed/checklists.$code.index'
import { Route as AuthedLeadsTypeIndexRouteImport } from './routes/_authed/leads/$type.index'
import { Route as AuthedLeadsTypeKeyRouteImport } from './routes/_authed/leads/$type.$key'
import { Route as AuthedStartLessonsNoRouteImport } from './routes/_authed/start.lessons.$no'
import { Route as AuthedChecklistsCodeRunsRunIdRouteImport } from './routes/_authed/checklists.$code.runs.$runId'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedChecklistsRoute = AuthedChecklistsRouteImport.update({
  id: '/checklists',
  path: '/checklists',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEvidenceRoute = AuthedEvidenceRouteImport.update({
  id: '/evidence',
  path: '/evidence',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedExportsRoute = AuthedExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFilesRoute = AuthedFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGanttRoute = AuthedGanttRouteImport.update({
  id: '/gantt',
  path: '/gantt',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLeadsRoute = AuthedLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNoAccessRoute = AuthedNoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPeopleRoute = AuthedPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSearchRoute = AuthedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStartRoute = AuthedStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTasksRoute = AuthedTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedVerificationRoute = AuthedVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminFreezesRoute = AuthedAdminFreezesRouteImport.update({
  id: '/freezes',
  path: '/freezes',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminImportsRoute = AuthedAdminImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminPacksRoute = AuthedAdminPacksRouteImport.update({
  id: '/packs',
  path: '/packs',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminPurgeRoute = AuthedAdminPurgeRouteImport.update({
  id: '/purge',
  path: '/purge',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedChecklistsIndexRoute = AuthedChecklistsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedChecklistsRoute,
} as any)
const AuthedEvidenceIndexRoute = AuthedEvidenceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedEvidenceRoute,
} as any)
const AuthedEvidenceCodeRoute = AuthedEvidenceCodeRouteImport.update({
  id: '/$code',
  path: '/$code',
  getParentRoute: () => AuthedEvidenceRoute,
} as any)
const AuthedLeadsIndexRoute = AuthedLeadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedLeadsRoute,
} as any)
const AuthedLeadsCapacityRoute = AuthedLeadsCapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => AuthedLeadsRoute,
} as any)
const AuthedStartIndexRoute = AuthedStartIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedStartRoute,
} as any)
const AuthedStartCompletionRoute = AuthedStartCompletionRouteImport.update({
  id: '/completion',
  path: '/completion',
  getParentRoute: () => AuthedStartRoute,
} as any)
const AuthedStartQuizRoute = AuthedStartQuizRouteImport.update({
  id: '/quiz',
  path: '/quiz',
  getParentRoute: () => AuthedStartRoute,
} as any)
const AuthedTasksIndexRoute = AuthedTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedTasksRoute,
} as any)
const AuthedTasksTaskIdRoute = AuthedTasksTaskIdRouteImport.update({
  id: '/$taskId',
  path: '/$taskId',
  getParentRoute: () => AuthedTasksRoute,
} as any)
const AuthedChecklistsCodeIndexRoute =
  AuthedChecklistsCodeIndexRouteImport.update({
    id: '/$code/',
    path: '/$code/',
    getParentRoute: () => AuthedChecklistsRoute,
  } as any)
const AuthedLeadsTypeIndexRoute = AuthedLeadsTypeIndexRouteImport.update({
  id: '/$type/',
  path: '/$type/',
  getParentRoute: () => AuthedLeadsRoute,
} as any)
const AuthedLeadsTypeKeyRoute = AuthedLeadsTypeKeyRouteImport.update({
  id: '/$type/$key',
  path: '/$type/$key',
  getParentRoute: () => AuthedLeadsRoute,
} as any)
const AuthedStartLessonsNoRoute = AuthedStartLessonsNoRouteImport.update({
  id: '/lessons/$no',
  path: '/lessons/$no',
  getParentRoute: () => AuthedStartRoute,
} as any)
const AuthedChecklistsCodeRunsRunIdRoute =
  AuthedChecklistsCodeRunsRunIdRouteImport.update({
    id: '/$code/runs/$runId',
    path: '/$code/runs/$runId',
    getParentRoute: () => AuthedChecklistsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/checklists': typeof AuthedChecklistsRouteWithChildren
  '/evidence': typeof AuthedEvidenceRouteWithChildren
  '/exports': typeof AuthedExportsRoute
  '/files': typeof AuthedFilesRoute
  '/gantt': typeof AuthedGanttRoute
  '/leads': typeof AuthedLeadsRouteWithChildren
  '/no-access': typeof AuthedNoAccessRoute
  '/people': typeof AuthedPeopleRoute
  '/search': typeof AuthedSearchRoute
  '/start': typeof AuthedStartRouteWithChildren
  '/tasks': typeof AuthedTasksRouteWithChildren
  '/verification': typeof AuthedVerificationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/freezes': typeof AuthedAdminFreezesRoute
  '/admin/imports': typeof AuthedAdminImportsRoute
  '/admin/packs': typeof AuthedAdminPacksRoute
  '/admin/purge': typeof AuthedAdminPurgeRoute
  '/admin/users': typeof AuthedAdminUsersRoute
  '/evidence/$code': typeof AuthedEvidenceCodeRoute
  '/leads/capacity': typeof AuthedLeadsCapacityRoute
  '/start/completion': typeof AuthedStartCompletionRoute
  '/start/quiz': typeof AuthedStartQuizRoute
  '/tasks/$taskId': typeof AuthedTasksTaskIdRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/checklists/': typeof AuthedChecklistsIndexRoute
  '/evidence/': typeof AuthedEvidenceIndexRoute
  '/leads/': typeof AuthedLeadsIndexRoute
  '/start/': typeof AuthedStartIndexRoute
  '/tasks/': typeof AuthedTasksIndexRoute
  '/leads/$type/$key': typeof AuthedLeadsTypeKeyRoute
  '/start/lessons/$no': typeof AuthedStartLessonsNoRoute
  '/checklists/$code/': typeof AuthedChecklistsCodeIndexRoute
  '/leads/$type/': typeof AuthedLeadsTypeIndexRoute
  '/checklists/$code/runs/$runId': typeof AuthedChecklistsCodeRunsRunIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/exports': typeof AuthedExportsRoute
  '/files': typeof AuthedFilesRoute
  '/gantt': typeof AuthedGanttRoute
  '/no-access': typeof AuthedNoAccessRoute
  '/people': typeof AuthedPeopleRoute
  '/search': typeof AuthedSearchRoute
  '/verification': typeof AuthedVerificationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthedIndexRoute
  '/admin/freezes': typeof AuthedAdminFreezesRoute
  '/admin/imports': typeof AuthedAdminImportsRoute
  '/admin/packs': typeof AuthedAdminPacksRoute
  '/admin/purge': typeof AuthedAdminPurgeRoute
  '/admin/users': typeof AuthedAdminUsersRoute
  '/evidence/$code': typeof AuthedEvidenceCodeRoute
  '/leads/capacity': typeof AuthedLeadsCapacityRoute
  '/start/completion': typeof AuthedStartCompletionRoute
  '/start/quiz': typeof AuthedStartQuizRoute
  '/tasks/$taskId': typeof AuthedTasksTaskIdRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/checklists': typeof AuthedChecklistsIndexRoute
  '/evidence': typeof AuthedEvidenceIndexRoute
  '/leads': typeof AuthedLeadsIndexRoute
  '/start': typeof AuthedStartIndexRoute
  '/tasks': typeof AuthedTasksIndexRoute
  '/leads/$type/$key': typeof AuthedLeadsTypeKeyRoute
  '/start/lessons/$no': typeof AuthedStartLessonsNoRoute
  '/checklists/$code': typeof AuthedChecklistsCodeIndexRoute
  '/leads/$type': typeof AuthedLeadsTypeIndexRoute
  '/checklists/$code/runs/$runId': typeof AuthedChecklistsCodeRunsRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/checklists': typeof AuthedChecklistsRouteWithChildren
  '/_authed/evidence': typeof AuthedEvidenceRouteWithChildren
  '/_authed/exports': typeof AuthedExportsRoute
  '/_authed/files': typeof AuthedFilesRoute
  '/_authed/gantt': typeof AuthedGanttRoute
  '/_authed/leads': typeof AuthedLeadsRouteWithChildren
  '/_authed/no-access': typeof AuthedNoAccessRoute
  '/_authed/people': typeof AuthedPeopleRoute
  '/_authed/search': typeof AuthedSearchRoute
  '/_authed/start': typeof AuthedStartRouteWithChildren
  '/_authed/tasks': typeof AuthedTasksRouteWithChildren
  '/_authed/verification': typeof AuthedVerificationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/admin/freezes': typeof AuthedAdminFreezesRoute
  '/_authed/admin/imports': typeof AuthedAdminImportsRoute
  '/_authed/admin/packs': typeof AuthedAdminPacksRoute
  '/_authed/admin/purge': typeof AuthedAdminPurgeRoute
  '/_authed/admin/users': typeof AuthedAdminUsersRoute
  '/_authed/evidence/$code': typeof AuthedEvidenceCodeRoute
  '/_authed/leads/capacity': typeof AuthedLeadsCapacityRoute
  '/_authed/start/completion': typeof AuthedStartCompletionRoute
  '/_authed/start/quiz': typeof AuthedStartQuizRoute
  '/_authed/tasks/$taskId': typeof AuthedTasksTaskIdRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/checklists/': typeof AuthedChecklistsIndexRoute
  '/_authed/evidence/': typeof AuthedEvidenceIndexRoute
  '/_authed/leads/': typeof AuthedLeadsIndexRoute
  '/_authed/start/': typeof AuthedStartIndexRoute
  '/_authed/tasks/': typeof AuthedTasksIndexRoute
  '/_authed/leads/$type/$key': typeof AuthedLeadsTypeKeyRoute
  '/_authed/start/lessons/$no': typeof AuthedStartLessonsNoRoute
  '/_authed/checklists/$code/': typeof AuthedChecklistsCodeIndexRoute
  '/_authed/leads/$type/': typeof AuthedLeadsTypeIndexRoute
  '/_authed/checklists/$code/runs/$runId': typeof AuthedChecklistsCodeRunsRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/checklists'
    | '/evidence'
    | '/exports'
    | '/files'
    | '/gantt'
    | '/leads'
    | '/no-access'
    | '/people'
    | '/search'
    | '/start'
    | '/tasks'
    | '/verification'
    | '/auth/callback'
    | '/admin/freezes'
    | '/admin/imports'
    | '/admin/packs'
    | '/admin/purge'
    | '/admin/users'
    | '/evidence/$code'
    | '/leads/capacity'
    | '/start/completion'
    | '/start/quiz'
    | '/tasks/$taskId'
    | '/admin/'
    | '/checklists/'
    | '/evidence/'
    | '/leads/'
    | '/start/'
    | '/tasks/'
    | '/leads/$type/$key'
    | '/start/lessons/$no'
    | '/checklists/$code/'
    | '/leads/$type/'
    | '/checklists/$code/runs/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/exports'
    | '/files'
    | '/gantt'
    | '/no-access'
    | '/people'
    | '/search'
    | '/verification'
    | '/auth/callback'
    | '/'
    | '/admin/freezes'
    | '/admin/imports'
    | '/admin/packs'
    | '/admin/purge'
    | '/admin/users'
    | '/evidence/$code'
    | '/leads/capacity'
    | '/start/completion'
    | '/start/quiz'
    | '/tasks/$taskId'
    | '/admin'
    | '/checklists'
    | '/evidence'
    | '/leads'
    | '/start'
    | '/tasks'
    | '/leads/$type/$key'
    | '/start/lessons/$no'
    | '/checklists/$code'
    | '/leads/$type'
    | '/checklists/$code/runs/$runId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/admin'
    | '/_authed/checklists'
    | '/_authed/evidence'
    | '/_authed/exports'
    | '/_authed/files'
    | '/_authed/gantt'
    | '/_authed/leads'
    | '/_authed/no-access'
    | '/_authed/people'
    | '/_authed/search'
    | '/_authed/start'
    | '/_authed/tasks'
    | '/_authed/verification'
    | '/auth/callback'
    | '/_authed/'
    | '/_authed/admin/freezes'
    | '/_authed/admin/imports'
    | '/_authed/admin/packs'
    | '/_authed/admin/purge'
    | '/_authed/admin/users'
    | '/_authed/evidence/$code'
    | '/_authed/leads/capacity'
    | '/_authed/start/completion'
    | '/_authed/start/quiz'
    | '/_authed/tasks/$taskId'
    | '/_authed/admin/'
    | '/_authed/checklists/'
    | '/_authed/evidence/'
    | '/_authed/leads/'
    | '/_authed/start/'
    | '/_authed/tasks/'
    | '/_authed/leads/$type/$key'
    | '/_authed/start/lessons/$no'
    | '/_authed/checklists/$code/'
    | '/_authed/leads/$type/'
    | '/_authed/checklists/$code/runs/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/checklists': {
      id: '/_authed/checklists'
      path: '/checklists'
      fullPath: '/checklists'
      preLoaderRoute: typeof AuthedChecklistsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/evidence': {
      id: '/_authed/evidence'
      path: '/evidence'
      fullPath: '/evidence'
      preLoaderRoute: typeof AuthedEvidenceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/exports': {
      id: '/_authed/exports'
      path: '/exports'
      fullPath: '/exports'
      preLoaderRoute: typeof AuthedExportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/files': {
      id: '/_authed/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AuthedFilesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gantt': {
      id: '/_authed/gantt'
      path: '/gantt'
      fullPath: '/gantt'
      preLoaderRoute: typeof AuthedGanttRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/leads': {
      id: '/_authed/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AuthedLeadsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/no-access': {
      id: '/_authed/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof AuthedNoAccessRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people': {
      id: '/_authed/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof AuthedPeopleRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/search': {
      id: '/_authed/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthedSearchRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/start': {
      id: '/_authed/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof AuthedStartRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tasks': {
      id: '/_authed/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthedTasksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/verification': {
      id: '/_authed/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof AuthedVerificationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/freezes': {
      id: '/_authed/admin/freezes'
      path: '/freezes'
      fullPath: '/admin/freezes'
      preLoaderRoute: typeof AuthedAdminFreezesRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/imports': {
      id: '/_authed/admin/imports'
      path: '/imports'
      fullPath: '/admin/imports'
      preLoaderRoute: typeof AuthedAdminImportsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/packs': {
      id: '/_authed/admin/packs'
      path: '/packs'
      fullPath: '/admin/packs'
      preLoaderRoute: typeof AuthedAdminPacksRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/purge': {
      id: '/_authed/admin/purge'
      path: '/purge'
      fullPath: '/admin/purge'
      preLoaderRoute: typeof AuthedAdminPurgeRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/users': {
      id: '/_authed/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthedAdminUsersRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/checklists/': {
      id: '/_authed/checklists/'
      path: '/'
      fullPath: '/checklists/'
      preLoaderRoute: typeof AuthedChecklistsIndexRouteImport
      parentRoute: typeof AuthedChecklistsRoute
    }
    '/_authed/evidence/': {
      id: '/_authed/evidence/'
      path: '/'
      fullPath: '/evidence/'
      preLoaderRoute: typeof AuthedEvidenceIndexRouteImport
      parentRoute: typeof AuthedEvidenceRoute
    }
    '/_authed/evidence/$code': {
      id: '/_authed/evidence/$code'
      path: '/$code'
      fullPath: '/evidence/$code'
      preLoaderRoute: typeof AuthedEvidenceCodeRouteImport
      parentRoute: typeof AuthedEvidenceRoute
    }
    '/_authed/leads/': {
      id: '/_authed/leads/'
      path: '/'
      fullPath: '/leads/'
      preLoaderRoute: typeof AuthedLeadsIndexRouteImport
      parentRoute: typeof AuthedLeadsRoute
    }
    '/_authed/leads/capacity': {
      id: '/_authed/leads/capacity'
      path: '/capacity'
      fullPath: '/leads/capacity'
      preLoaderRoute: typeof AuthedLeadsCapacityRouteImport
      parentRoute: typeof AuthedLeadsRoute
    }
    '/_authed/start/': {
      id: '/_authed/start/'
      path: '/'
      fullPath: '/start/'
      preLoaderRoute: typeof AuthedStartIndexRouteImport
      parentRoute: typeof AuthedStartRoute
    }
    '/_authed/start/completion': {
      id: '/_authed/start/completion'
      path: '/completion'
      fullPath: '/start/completion'
      preLoaderRoute: typeof AuthedStartCompletionRouteImport
      parentRoute: typeof AuthedStartRoute
    }
    '/_authed/start/quiz': {
      id: '/_authed/start/quiz'
      path: '/quiz'
      fullPath: '/start/quiz'
      preLoaderRoute: typeof AuthedStartQuizRouteImport
      parentRoute: typeof AuthedStartRoute
    }
    '/_authed/tasks/': {
      id: '/_authed/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthedTasksIndexRouteImport
      parentRoute: typeof AuthedTasksRoute
    }
    '/_authed/tasks/$taskId': {
      id: '/_authed/tasks/$taskId'
      path: '/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AuthedTasksTaskIdRouteImport
      parentRoute: typeof AuthedTasksRoute
    }
    '/_authed/checklists/$code/': {
      id: '/_authed/checklists/$code/'
      path: '/$code'
      fullPath: '/checklists/$code/'
      preLoaderRoute: typeof AuthedChecklistsCodeIndexRouteImport
      parentRoute: typeof AuthedChecklistsRoute
    }
    '/_authed/leads/$type/': {
      id: '/_authed/leads/$type/'
      path: '/$type'
      fullPath: '/leads/$type/'
      preLoaderRoute: typeof AuthedLeadsTypeIndexRouteImport
      parentRoute: typeof AuthedLeadsRoute
    }
    '/_authed/leads/$type/$key': {
      id: '/_authed/leads/$type/$key'
      path: '/$type/$key'
      fullPath: '/leads/$type/$key'
      preLoaderRoute: typeof AuthedLeadsTypeKeyRouteImport
      parentRoute: typeof AuthedLeadsRoute
    }
    '/_authed/start/lessons/$no': {
      id: '/_authed/start/lessons/$no'
      path: '/lessons/$no'
      fullPath: '/start/lessons/$no'
      preLoaderRoute: typeof AuthedStartLessonsNoRouteImport
      parentRoute: typeof AuthedStartRoute
    }
    '/_authed/checklists/$code/runs/$runId': {
      id: '/_authed/checklists/$code/runs/$runId'
      path: '/$code/runs/$runId'
      fullPath: '/checklists/$code/runs/$runId'
      preLoaderRoute: typeof AuthedChecklistsCodeRunsRunIdRouteImport
      parentRoute: typeof AuthedChecklistsRoute
    }
  }
}

interface AuthedAdminRouteChildren {
  AuthedAdminFreezesRoute: typeof AuthedAdminFreezesRoute
  AuthedAdminImportsRoute: typeof AuthedAdminImportsRoute
  AuthedAdminPacksRoute: typeof AuthedAdminPacksRoute
  AuthedAdminPurgeRoute: typeof AuthedAdminPurgeRoute
  AuthedAdminUsersRoute: typeof AuthedAdminUsersRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminFreezesRoute: AuthedAdminFreezesRoute,
  AuthedAdminImportsRoute: AuthedAdminImportsRoute,
  AuthedAdminPacksRoute: AuthedAdminPacksRoute,
  AuthedAdminPurgeRoute: AuthedAdminPurgeRoute,
  AuthedAdminUsersRoute: AuthedAdminUsersRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedChecklistsRouteChildren {
  AuthedChecklistsIndexRoute: typeof AuthedChecklistsIndexRoute
  AuthedChecklistsCodeIndexRoute: typeof AuthedChecklistsCodeIndexRoute
  AuthedChecklistsCodeRunsRunIdRoute: typeof AuthedChecklistsCodeRunsRunIdRoute
}

const AuthedChecklistsRouteChildren: AuthedChecklistsRouteChildren = {
  AuthedChecklistsIndexRoute: AuthedChecklistsIndexRoute,
  AuthedChecklistsCodeIndexRoute: AuthedChecklistsCodeIndexRoute,
  AuthedChecklistsCodeRunsRunIdRoute: AuthedChecklistsCodeRunsRunIdRoute,
}

const AuthedChecklistsRouteWithChildren =
  AuthedChecklistsRoute._addFileChildren(AuthedChecklistsRouteChildren)

interface AuthedEvidenceRouteChildren {
  AuthedEvidenceCodeRoute: typeof AuthedEvidenceCodeRoute
  AuthedEvidenceIndexRoute: typeof AuthedEvidenceIndexRoute
}

const AuthedEvidenceRouteChildren: AuthedEvidenceRouteChildren = {
  AuthedEvidenceCodeRoute: AuthedEvidenceCodeRoute,
  AuthedEvidenceIndexRoute: AuthedEvidenceIndexRoute,
}

const AuthedEvidenceRouteWithChildren = AuthedEvidenceRoute._addFileChildren(
  AuthedEvidenceRouteChildren,
)

interface AuthedLeadsRouteChildren {
  AuthedLeadsCapacityRoute: typeof AuthedLeadsCapacityRoute
  AuthedLeadsIndexRoute: typeof AuthedLeadsIndexRoute
  AuthedLeadsTypeKeyRoute: typeof AuthedLeadsTypeKeyRoute
  AuthedLeadsTypeIndexRoute: typeof AuthedLeadsTypeIndexRoute
}

const AuthedLeadsRouteChildren: AuthedLeadsRouteChildren = {
  AuthedLeadsCapacityRoute: AuthedLeadsCapacityRoute,
  AuthedLeadsIndexRoute: AuthedLeadsIndexRoute,
  AuthedLeadsTypeKeyRoute: AuthedLeadsTypeKeyRoute,
  AuthedLeadsTypeIndexRoute: AuthedLeadsTypeIndexRoute,
}

const AuthedLeadsRouteWithChildren = AuthedLeadsRoute._addFileChildren(
  AuthedLeadsRouteChildren,
)

interface AuthedStartRouteChildren {
  AuthedStartCompletionRoute: typeof AuthedStartCompletionRoute
  AuthedStartQuizRoute: typeof AuthedStartQuizRoute
  AuthedStartIndexRoute: typeof AuthedStartIndexRoute
  AuthedStartLessonsNoRoute: typeof AuthedStartLessonsNoRoute
}

const AuthedStartRouteChildren: AuthedStartRouteChildren = {
  AuthedStartCompletionRoute: AuthedStartCompletionRoute,
  AuthedStartQuizRoute: AuthedStartQuizRoute,
  AuthedStartIndexRoute: AuthedStartIndexRoute,
  AuthedStartLessonsNoRoute: AuthedStartLessonsNoRoute,
}

const AuthedStartRouteWithChildren = AuthedStartRoute._addFileChildren(
  AuthedStartRouteChildren,
)

interface AuthedTasksRouteChildren {
  AuthedTasksTaskIdRoute: typeof AuthedTasksTaskIdRoute
  AuthedTasksIndexRoute: typeof AuthedTasksIndexRoute
}

const AuthedTasksRouteChildren: AuthedTasksRouteChildren = {
  AuthedTasksTaskIdRoute: AuthedTasksTaskIdRoute,
  AuthedTasksIndexRoute: AuthedTasksIndexRoute,
}

const AuthedTasksRouteWithChildren = AuthedTasksRoute._addFileChildren(
  AuthedTasksRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedChecklistsRoute: typeof AuthedChecklistsRouteWithChildren
  AuthedEvidenceRoute: typeof AuthedEvidenceRouteWithChildren
  AuthedExportsRoute: typeof AuthedExportsRoute
  AuthedFilesRoute: typeof AuthedFilesRoute
  AuthedGanttRoute: typeof AuthedGanttRoute
  AuthedLeadsRoute: typeof AuthedLeadsRouteWithChildren
  AuthedNoAccessRoute: typeof AuthedNoAccessRoute
  AuthedPeopleRoute: typeof AuthedPeopleRoute
  AuthedSearchRoute: typeof AuthedSearchRoute
  AuthedStartRoute: typeof AuthedStartRouteWithChildren
  AuthedTasksRoute: typeof AuthedTasksRouteWithChildren
  AuthedVerificationRoute: typeof AuthedVerificationRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedChecklistsRoute: AuthedChecklistsRouteWithChildren,
  AuthedEvidenceRoute: AuthedEvidenceRouteWithChildren,
  AuthedExportsRoute: AuthedExportsRoute,
  AuthedFilesRoute: AuthedFilesRoute,
  AuthedGanttRoute: AuthedGanttRoute,
  AuthedLeadsRoute: AuthedLeadsRouteWithChildren,
  AuthedNoAccessRoute: AuthedNoAccessRoute,
  AuthedPeopleRoute: AuthedPeopleRoute,
  AuthedSearchRoute: AuthedSearchRoute,
  AuthedStartRoute: AuthedStartRouteWithChildren,
  AuthedTasksRoute: AuthedTasksRouteWithChildren,
  AuthedVerificationRoute: AuthedVerificationRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
